import { FlexBox } from "@styles";
import React from "react";
import styled from "styled-components";
import ProductContentFlatList from "@components/FlatList/ProductContentFlatList";

interface IFeaturedContentProps {
  featured_content: readonly Queries.ProductContentFragment[];
  more_content_slug: string;
  more_content_text?: string;
  featured_videos: readonly Queries.VideoFragment[];
  more_videos_slug: string;
  more_videos_text?: string;
  newTab?: boolean;
}

const Divider = styled.span`
  width: 100%;
  height: 2px;
  background-color: #fff;
  margin-block: 1rem;
`;

const Button = styled.a`
  background-color: #12b8f6;
  text-align: center;
  margin-block: 1rem;
  color: #000;
  font-weight: 700;
  max-width: max-content;
  text-decoration: none;
  padding: 0.5rem 1.5rem;
  border-radius: 0.7rem;
  font-size: 1.2rem;
  margin-inline: auto;
`;

const FeaturedContent = ({
  featured_content,
  featured_videos,
  more_content_slug,
  more_content_text = "All related articles",
  more_videos_slug,
  more_videos_text = "All related videos",
  newTab,
}: IFeaturedContentProps) => {
  if (featured_content.length === 0 && featured_videos.length === 0) return null;

  return (
    <>
      {featured_content.length > 0 && (
        <FlexBox direction="column" justifyContent="center">
          <ProductContentFlatList content={[...featured_content]} listDisplayType="feature" />

          <Button href={more_content_slug} target={newTab ? "_blank" : "_self"}>
            {more_content_text}
          </Button>
        </FlexBox>
      )}

      {featured_content.length > 0 && featured_videos.length > 0 && <Divider />}

      {featured_videos.length > 0 && (
        <FlexBox direction="column">
          <ProductContentFlatList videos={[...featured_videos]} listDisplayType="feature" />
          <Button href={more_videos_slug} target={newTab ? "_blank" : "_self"}>
            {more_videos_text}
          </Button>
        </FlexBox>
      )}
    </>
  );
};

export default FeaturedContent;
